module.exports = __webpack_public_path__ + "static/media/sg_1.f6d6ba5a.mp3";